import React from 'react';
import { Table, Dropdown } from 'semantic-ui-react';

const ListRow = actionHandler => defaultCoverageOptOut => {
  const rowMenuOptions = [
    { key: 1, text: 'Edit', value: 'Edit' },
    { key: 2, text: 'Delete', value: 'Delete' },
  ];

  const {
    id,
    buyerNumber,
    sellerNumber,
    auctionAccessNumber,
    productId,
    productCode,
    startDate,
    endDate,
    notes,
    createdBy,
    createdAt,
    updatedBy,
    status,
  } = defaultCoverageOptOut;

  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, defaultCoverageOptOut);
  };

  return (
    <Table.Row key={id}>
      <Table.Cell>{buyerNumber}</Table.Cell>
      <Table.Cell data-testid='default-coverage-opt-out-aan'>
        {auctionAccessNumber}
      </Table.Cell>
      <Table.Cell>{sellerNumber}</Table.Cell>
      <Table.Cell>{productCode || productId}</Table.Cell>
      <Table.Cell>{startDate}</Table.Cell>
      <Table.Cell>{endDate}</Table.Cell>
      <Table.Cell>{notes}</Table.Cell>
      <Table.Cell>{status}</Table.Cell>
      <Table.Cell data-testid='default-coverage-opt-out-created-by'>
        {createdBy}
      </Table.Cell>
      <Table.Cell>
        {createdAt
          ? `${String(createdAt).substring(0, 19).replace('T', ' ')} UTC`
          : ''}
      </Table.Cell>
      <Table.Cell data-testid='default-coverage-opt-out-updated-by'>
        {updatedBy}
      </Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          options={rowMenuOptions}
          icon='ellipsis horizontal'
          onChange={handleActionChange}
          inline
          item
          selectOnBlur={false}
          value={null}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default ListRow;
